export interface IUserProfile {
  userId?: string;
  birthDate?: Date;
  email: string;
  firstName: string;
  isEmailConfirmed: boolean;
  phone: string;
  cardNumber: string;
}

export interface IUserPermissionsResponse {
  calls: boolean;
  digital_receipt: boolean;
  email: boolean;
  push_content: boolean;
  push_mass: boolean;
  push_pers: boolean;
  sms: boolean;
  social: boolean;
}
export interface IUserPermissions {
  // Персональные предложения
  isPushPersPermitted: boolean;
  // Акции
  isPushMassPermitted: boolean;
  // Развлекательный контент
  isPushContentPermitted: boolean;
  // Письма
  isEmailPermitted: boolean;
  // Сообщения в мессенджерах и смс
  isSmsPermitted: boolean;
  // Сообщения в социальных сетях
  isSocialPermitted: boolean;
  // Звонки
  isCallsPermitted: boolean;
  // Электронные чеки
  isDigitalReceiptPermitted: boolean;
}

export enum OfferStatus {
  NotInteractive = "NOT_INTERACTIVE",
  InteractiveWithCoupon = "INTERACTIVE_WITH_COUPON",
  OptedInCoupon = "OPTED_IN_COUPON",
  InteractiveWithoutCoupon = "INTERACTIVE_WITHOUT_COUPON",
  OptedIn = "OPTED_IN",
}

export enum OfferUnit {
  Points = "points",
  ValueDiscount = "valueDiscount",
  PercentDiscount = "percentDiscount",
  IncreaseAccrual = "increaseAccrual",
  Cashback = "cashback",
  FixPrice = "fixPrice",
  Promocode = "promocode",
  Collections = "collections",
}

export interface IOffer {
  activeStatus?: string;
  canAcceptOffer?: boolean;
  category: string;
  code: string;
  completeDate?: string;
  description?: string;
  endDate?: string;
  isBenefitHighlighted?: boolean;
  largeImageUrl?: string;
  legalTermsUrl?: string;
  name: string;
  offerStatus?: OfferStatus;
  optedInDate?: string;
  smallImageUrl?: string;
  startDate?: string;
  unit?: OfferUnit;
  value?: number;
}

export interface IUserFavoriteCategories {
  maxOptIn: number;
  offers: IOffer[];
}

export interface ISubSection {
  generalOffers: IOffer[];
  icon: string;
  title: string;
}

export interface ISection {
  maxCount: number;
  sectionIcon: string;
  sectionTitle?: string;
  subSections: ISubSection[];
}

export interface IUserFavoriteSectionCategories {
  maxOptIn: number;
  sections: ISection[];
}

export enum TickStatus {
  inProgress = "inProgress",
  skipped = "skipped",
  notStarted = "notStarted",
  done = "done",
}
export enum TickType {
  basic = "basic",
  first = "first",
  second = "second",
}

export interface IUserBalanceResponse {
  isCache?: boolean;
  items: Array<{
    points: number;
    type: string;
    visibleForCustomer: boolean;
  }>;
  priority?: number;
  totalExpressPoints: number;
  totalPointBalance: number;
}

export interface IUserBenefitsResponse {
  benefits: {
    currentBonusPercentage: number;
    homeRegionBenefit: {
      defaultAcceptable: boolean;
      offerCode: string;
      status: string;
      text: {
        actionDescription: string;
        actionTitle: string;
        bannerButton: string;
        bannerTitle: string;
        successDescription: string;
        successTitle: string;
      };
    };
    ticks: Array<{
      bonusPercentage?: number;
      currentMoneyAmount: number;
      currentProducts: number;
      leftToBuyMoneyAmount?: number;
      leftToBuyProducts?: number;
      moneyAmount: number;
      products: number;
      status: TickStatus;
      type?: TickType;
    }>;
  };
  faq: Array<{
    description: string;
    title: string;
  }>;
}

export interface IUserNextStickerExpirationResponse {
  expirationDate?: string; // date, example: 2020-06-04
  points?: number;
}

export interface IUserCardsIdentifier {
  cobranded: boolean;
  id: string;
  identifierNo: string;
  identifierTypeCode: string;
  isIdentifierTypeVirtual: boolean;
  redemptionEnabled: boolean;
  status: string;
  statusName: string;
}

export interface IUserCardsResponse {
  identifiers: IUserCardsIdentifier[];
  isMergeEnabled: boolean;
  maxPlasticCards: number;
}

export enum Gender {
  male = "male",
  female = "female",
}

export interface IUserProfileResponse {
  birthDate?: string; //  1990-01-01
  email?: string;
  firstName?: string;
  gender?: Gender;
  isAdult?: boolean;
  isEmailConfirmed: boolean;
  isEmployee?: boolean;
  lastName?: string;
  phone: string;
  userId: string;
}

export interface ISendTotpResponse {
  identifier: string;
  totp: string;
}
